import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
 
import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./context/PrivateRoute";
import OAuth2RedirectHandler from "./context/OAuth2RedirectHandler";

import Home from "./pages/Home.js";
import LoginMenu from "./pages/LoginMenu";
import Main from "./pages/Main";
import Scanfree from "./pages/Scanfree"; 

const App = () => {
  return (
    <Router>
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginMenu />} />
      <Route path="/scanfree" element={<Scanfree />} />
        <Route
          path="/main"
          element={
            <PrivateRoute>
              <Main />
            </PrivateRoute>
          }
        />
        {/* Redirección después de autenticación OAuth2 */}
        <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />
      </Routes>
    </Router>
  );
};

export default App;

/*


return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<LoginMenu />} />
          <Route path="/api/auth/login/google" element={<LoginMenu />} />

          <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />

          <Route path="/main" element={ <PrivateRoute> <Main /> </PrivateRoute> } />

 
        </Routes>
      </AuthProvider>
    </Router>
  );








import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Header from "./components/Header";
import Main from "./components/Main";
import Footer from "./components/Footer";

const App = () => {
  const [user, setUser] = useState(null);

  const handleLogout = () => {
    setUser(null);
    window.location.reload();
  };

  const handleLogin =  () => {
    window.location.href = "/login";
  };

   

  
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (token) {
      localStorage.setItem("accessToken", token);
      window.history.replaceState({}, document.title, "/");
    }
  }, []);

  return (
    <Router>
      <Header user={user} onLogout={handleLogout} onLogin={handleLogin} />
      <Main user={user}  onInit={checkLogin} />
      <Footer />
    </Router>
  );
};

export default App;


import React, { useEffect } from 'react';
import api from './services/api';

const App = () => {
    const handleLogin = async () => {
        window.location.href = '/oauth2/authorize/google';
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        if (token) {
            localStorage.setItem('accessToken', token);
            window.history.replaceState({}, document.title, '/');
        }
    }, []);

    const fetchData = async () => {
        try {
            const response = await api.get('/protected-data');
            console.log(response.data);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <div>
            <button onClick={handleLogin}>Login with Google</button>
            <button onClick={fetchData}>Fetch Protected Data</button>
        </div>
    );
};

export default App;
*/
